import { FILTER_CONFIG_NAMES } from './DataConstants';
import ProblemTypeTreeSelect from '../components/problem_type_tree_select';

export const getLocationFilterConfig = ({
	filters,
	brandAvailable = false,
	additionalFieldsFilter = null,
	showCustomers = false,
}: {
	filters: any;
	brandAvailable?: boolean;
	additionalFieldsFilter?: any;
	showCustomers?: boolean;
}) => {
	const regionFilter = filters[FILTER_CONFIG_NAMES.REGION];
	return [
		...(showCustomers ? [filters[FILTER_CONFIG_NAMES.CUSTOMERS]] : []),
		regionFilter && { ...regionFilter, component: ProblemTypeTreeSelect },
		filters[FILTER_CONFIG_NAMES.LOCAATION_TYPE],
		...(brandAvailable ? [filters[FILTER_CONFIG_NAMES.BRAND]] : []),
		...(additionalFieldsFilter ? [additionalFieldsFilter] : []),
		filters[FILTER_CONFIG_NAMES.IS_ACTIVE] && {
			...filters[FILTER_CONFIG_NAMES.IS_ACTIVE],
			showOutsideDropdown: true,
			info: undefined,
		},
	].filter(Boolean);
};
